import React from 'react';
import Reflux from 'reflux';
import SuggestedUsers from '../sections/SuggestedUsers';
import SuggestedComments from '../sections/SuggestedComments';
import TopList from '../sections/TopList';
import UserList from '../sections/UserList';
import SearchStore from '../stores/SearchStore';
import SearchActions from '../actions/SearchActions';
import WheelLoader from '../components/wheelloader/WheelLoader';
import RcIf, {RcElse} from 'rc-if';

export default class SearchResults extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {
            filtersClass: false,
            searchFilterfollowing: false,
            searchFilterAll: true,
            activeTab: 'highlights',
            query: this.props.query
        };
        this.store = SearchStore;
    }
    filtersShow (e) {
        e.preventDefault();
        this.setState({
            filtersClass: (this.state.filtersClass
            ? ''
            : 'showFilters')
        });
    }
    componentDidMount () {
        SearchActions.search(this.props.query);
        SearchActions.getUserSuggestions();
    }

    componentDidUpdate () {
        this.evaluateChangeTab();
    }

    evaluateChangeTab = () => {
        if (
           this.state.searchResult.usertopics &&
           this.state.searchResult.usertopics.length === 0 &&
           this.state.searchResult.users &&
           this.state.searchResult.users.length > 0 &&
           this.state.activeTab !== 'users'
        ) {
            this.setState({activeTab: 'users'});
        }
    }

    componentWillReceiveProps (newProps) {
        if (this.state.query !== newProps.query) {
            this.setState({query: newProps.query});
            SearchActions.search(newProps.query);
        }
    }
    onChangeFilterFollowing = (event) => {
        if (event.target.id === 'following') {
            this.setState({searchFilterAll: !this.state.searchFilterfollowing});
            SearchActions.filterResultsFollowing();
        }
        if (event.target.id === 'all') {
            this.setState({searchFilterfollowing: !this.state.searchFilterAll});
            SearchActions.search(this.props.query);
        }
    }
    changeTab = (tab) => {
        this.setState({ activeTab: tab });
    }

    render () {
        return (
          <main>
            <div className='row headerTopic space-top searchHeader'>
              <div className='container-gral'>
                <div className='col s12 top-search'>
                  <span>Buscaste</span>
                  <p>{this.props.query}</p>
                </div>
              </div>
            </div>
            <div className='row cat-search nomargin'>
              <div className='container-gral'>
                <div className='col s12'>
                  <ul>
                    <li onClick={() => { this.changeTab('highlights'); }} className={this.state.activeTab === 'highlights' ? 'active-tab-search' : ''}>
                      <a>Destacados</a>
                    </li>
                    <li onClick={() => { this.changeTab('users'); }} className={this.state.activeTab === 'users' ? 'active-tab-search' : ''}>
                      <a>Usuarios</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='container-gral pad-nocat'>
                <div className='col l9 s12'>
                  <RcIf if={!this.state.searching}>
                    <RcIf if={this.state.activeTab === 'highlights'}>
                      <div className='result-col'>
                        <h4 className='title-home'>
                          <span>Destacados</span>
                        </h4>
                        <div className='box-result result-content'>
                          <RcIf if={this.state.searchResult.usertopics.length > 0}>
                            <TopList tops={this.state.searchResult.usertopics} />
                            <RcElse>
                              <div className='not-result-box'>
                                <img src='/images/icons/notfollow.svg' />
                                <h6>No se encontraron resultados</h6>
                                <p>Podés intentarlo de nuevo encribiendo de manera diferente</p>
                                <p>Crear un <a href='/new'>Top5 nuevo</a> si el tema que buscás no existe aún. </p>
                              </div>
                            </RcElse>
                          </RcIf>
                        </div>
                      </div>
                      <RcElse>
                        <div className='result-col'>
                          <h4 className='title-home'>
                            <span>Usuarios</span>
                          </h4>
                          <UserList type='search' users={this.state.searchResult.users} />
                        </div>
                      </RcElse>
                    </RcIf>
                    <RcElse>
                      <WheelLoader />
                    </RcElse>
                  </RcIf>
                </div>
                <div className='col l3 s12'>
                  <div className='box-filter bottom-mar'>
                    <h5>Filtrar resultados</h5>
                    <a className='closeFilters' onClick={(e) => this.filtersShow(e)}>
                      {this.state.filtersClass ? 'Ocultar' : 'Mostrar'}
                    </a>
                    <div className={'showFiltersContainer ' + this.state.filtersClass}>
                      <div className='item-filter'>
                        <h6>Publicaciones de</h6>
                        <form>
                          <p>
                            <input type='radio' className='browser-defaul with-gap' name='filter-tops' id='all' onChange={this.onChangeFilterFollowing} defaultChecked />
                            <label htmlFor='all'>Todos</label>
                          </p>
                          <p>
                            <input type='radio' className='browser-default with-gap' name='filter-tops' id='following' onChange={this.onChangeFilterFollowing} />
                            <label htmlFor='following'>Seguidos</label>
                          </p>
                        </form>
                      </div>
                    </div>
                  </div>
                  <SuggestedUsers />
                  <SuggestedComments />
                </div>
              </div>
            </div>
          </main>
        );
    }
}



// WEBPACK FOOTER //
// ./src/sections/SearchResults.js